/* eslint-disable */
// prettier-ignore-start
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './scss/index.scss';
import App from './components/App';
//import * as serviceWorkerRegistration from './serviceWorkerRegistration';
//import reportWebVitals from './reportWebVitals';
import { configureSite, configureMap } from './config/AppConfig';
import configureStore from './store';
import { getConfig } from './store/actions/Index.actions';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { id } from 'date-fns/locale';
import { clearAuthAndRedirect } from './utils/tokenExpiry';

let msalInstance: PublicClientApplication;


const ALLOWED_QUERY_PARAM_KEYS = ['isApproved', 'subscriberId'] as const;
type AllowedQueryParamKey = typeof ALLOWED_QUERY_PARAM_KEYS[number];

// ✅ Validate value — allow only safe alphanumeric strings
const sanitizeQueryParamValue = (value: string): string | null => {
  const SAFE_VALUE_REGEX = /^[a-zA-Z0-9_-]+$/;
  return SAFE_VALUE_REGEX.test(value) ? value : null;
};

// ✅ Guard against prototype pollution keys
const isSafeKey = (key: string): key is AllowedQueryParamKey => {
  return (
    ALLOWED_QUERY_PARAM_KEYS.includes(key as AllowedQueryParamKey) &&
    key !== '__proto__' &&
    key !== 'constructor' &&
    key !== 'prototype'
  );
};

const urlData = window.location.search;

// Parse the query string using URLSearchParams
const params = new URLSearchParams(urlData);

// ✅ Use null-prototype object to prevent prototype pollution entirely
const queryParams: Record<AllowedQueryParamKey, string | null> = Object.create(null);

for (const [key, value] of params) {
  if (isSafeKey(key)) {
    queryParams[key] = sanitizeQueryParamValue(value); // ✅ sanitize before storing
  }
}

const store = configureStore();
configureSite();
configureMap()
  .then((config) => {
    store.dispatch(getConfig(config));

    // msal configuration
    const msalConfigAd = {
      auth: {
        clientId: config.AAD_Client_ID,
        authority: config.AAD_Authority,
        redirectUri: config.AAD_Redirect_Url,
      },
      cache: {
        cacheLocation: config.AAD_Cache_Location, // This configures where your cache will be stored
        storeAuthStateInCookie: config.AAD_StoreAuthStateInCookie, // Set this to "true" if you are having issues on IE11 or Edge
      },
      system: {
        loggerOptions: {
          loggerCallback: (level: any, message: any, containsPii: any) => {
            if (containsPii) {
              return;
            }
            switch (level) {
              case LogLevel.Error:
                console.error(message);
                return;
              case LogLevel.Info:
                console.log(message);
                return;
              case LogLevel.Verbose:
                console.debug(message);
                return;
            }
          },
        },
      },
    };
    const msalConfigB2C = {
      auth: {
        navigateToLoginRequestUrl: false,
        clientId: config.B2C_Client_ID, // B2C Client Id,  This is the ONLY mandatory field; everything else is optional.
        authority: config.B2C_SignUp_SignIn, // Choose sign-up/sign-in user-flow as your default.
        knownAuthorities: [config.B2C_knownAuthorities], // You must identify your tenant's domain as a known authority.
        redirectUri: config.B2C_Redirect_URL, // You must register this URI on Azure Portal/App Registration. Defaults to "window.location.href".
      },
      cache: {
        cacheLocation: config.B2C_Cache_Location, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: true, // If you wish to store cache items in cookies as well as browser cache, set this to "true".
      },
      system: {
        loggerOptions: {
          loggerCallback: (level: any, message: any, containsPii: any) => {
            if (containsPii) {
              return;
            }
            switch (level) {
              case LogLevel.Error:
                console.error(message);
                return;
              case LogLevel.Info:
                console.log(message);
                return;
              case LogLevel.Verbose:
                console.debug(message);
                return;
            }
          },
        },
      },
    };

    if (config.USER_TYPE === 'operator') {
      const isApproved = queryParams.isApproved;
      const subscriberId = queryParams.subscriberId;
      // ✅ Only store if values passed sanitization
      if (isApproved !== null && isApproved !== undefined) {
        window.sessionStorage.setItem('isApproved', isApproved);
      }
      if (subscriberId !== null && subscriberId !== undefined) {
        window.sessionStorage.setItem('subscriberId', subscriberId);
      }
    }

    const msalConfig =
      config.USER_TYPE === 'operator' ? msalConfigAd : msalConfigB2C;
    msalInstance = new PublicClientApplication(msalConfig);

    //interceptor
    axios.interceptors.request.use(
      (request) => {
        request.headers.Authorization = `Bearer ${localStorage.getItem(
          'userToken',
        )}`;
        return request;
      },
      (error) => {
        console.log('Request Error:', error);
        return Promise.reject(error);
      },
    );

    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response?.status === 401) {
          // msalInstance.logoutRedirect({
          //   postLogoutRedirectUri: '/',
          // });
          const signUpRequest = {
            scopes: [config.B2C_Scope],
            authority: config.B2C_Redirect_URL,
          };
          clearAuthAndRedirect();
          }
        return Promise.reject(error);
      },
    );

    const AppProvider = () => (
      <React.StrictMode>
        <Provider store={store}>
          <MsalProvider instance={msalInstance}>
            <App userType={config.USER_TYPE} />
          </MsalProvider>
        </Provider>
      </React.StrictMode>
    );
    ReactDOM.render(<AppProvider />, document.getElementById('root'));
  })
  .catch(() => {
    const AppProvider = () => (
      <React.StrictMode>
        <Provider store={store}>
          <App userType="" />
        </Provider>
      </React.StrictMode> 
    );
    ReactDOM.render(<AppProvider />, document.getElementById('root'));
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
